import { useEffect } from 'react'

export const useHandleArticleToggle = (content: string) => {
  useEffect(() => {
    if (!content) return

    const previews = [...document.getElementsByClassName('toggle_preview')]

    function toggle(this: HTMLElement, e: Event) {
      e.preventDefault()
      ;(this.parentNode as HTMLElement)?.classList.toggle('toggle-collapsed')
    }

    previews.forEach((preview) => {
      const parent = preview.parentNode as HTMLElement
      if (!parent.hasAttribute('data-toggle-initialized')) {
        preview.addEventListener('click', toggle)
        parent.setAttribute('data-toggle-initialized', 'true')
      }
    })

    return () => {
      previews.forEach((preview) => {
        preview.removeEventListener('click', toggle)
      })
    }
  }, [content])
}
